import { computed, inject, Injectable } from '@angular/core';

import { ThemeService } from '../theme/theme.service';
import { CHART_CHROME, CHART_PALETTE, ChartChrome, ChartPalette } from './chart-theme.const';

@Injectable({ providedIn: 'root' })
export class ChartThemeService {
  private readonly themeService = inject(ThemeService);

  public readonly palette = computed<ChartPalette>(
    () => CHART_PALETTE[this.themeService.themeSignal()],
  );

  public readonly chrome = computed<ChartChrome>(
    () => CHART_CHROME[this.themeService.themeSignal()],
  );

  public cardColor(field: string): string {
    return this.palette().cardBg[field];
  }

  public cardHighlightColor(field: string): string {
    return this.palette().cardHighlight[field] ?? this.cardColor(field);
  }

  public cardTextColor(field: string): string {
    return this.palette().cardText[field];
  }

  public generatedColors(): string[] {
    return Array.from(this.palette().generated);
  }

  /**
   * Re-resolves `color` from the key each item already carries. Returns new
   * objects in a new array: apx-chart only repaints when the bound reference
   * changes, so mutating in place would silently do nothing.
   */
  public recolor<T extends { color: string }>(items: T[], key: keyof T): T[] {
    return items.map((item) => ({ ...item, color: this.cardColor(String(item[key])) }));
  }
}
